// has-role.directive.ts
import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { Subscription } from 'rxjs';
import { RoleEnum } from '../consts/role.const';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective implements OnDestroy {
  private requiredRoles: string[] | RoleEnum[] = [];
  private subscription?: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) { }

  @Input() set appHasRole(roles: string[] | RoleEnum[]) {
    this.requiredRoles = roles;
    this.viewContainer.clear();
    // disable rendering if no roles are specified
    if (!this.requiredRoles || !this.requiredRoles.filter(Boolean).length) {
      // do not render content
      return;
    }
    this.updateView();
  }

  private updateView(): void {
    const hasRole = this.authService.hasRequiredRole(this.requiredRoles);
    this.viewContainer.clear();
    if (hasRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }


  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}